
export const calculateEpaAverage = (reportChartRadonValue) => {
    const rawData = reportChartRadonValue || [];
    const data = rawData.length > 0 && Array.isArray(rawData[0]) ? rawData.flat() : rawData;

    let sum = 0;
    let count = 0;

    if (data.length <= 4) {
        return 0;
    } else {
        for (let i = 4; i < data.length; i++) {
            sum += parseFloat(data[i].radon_level);
        }
        count = data.length - 4;
    }

    return count === 0 ? 0 : sum / count;
};

export const reformatRadonAvgData = (data, unit, point) => {
    if (data === "" || data === undefined) {
        return "N/A";
    } else {
        if (unit === 0) {
            return (data).toFixed(point) + " pCi/L";
        } else {
            return data.toFixed(0) + " Bq/m3";
        }
    }
};
